import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { useFormikContext } from "formik";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../Typography/Title";
import NormalText from "../../Typography/NormalText";
import { ActionTopBoxStyled } from "../common-styled/ActionTopBoxStyled";
import StressTypeInput from "components/action-inputs/stress-type/StressTypeInput";
import StressSelectInput from "components/action-inputs/stress/StressSelectInput";
import EnemySelectInput from "components/action-inputs/enemy/EnemySelectInput";

const CauseTitleSection = styled("div")({
  display: "flex",
  gap: "12px",
  alignItems: "center",
});

const EmptyPlaceholder = styled("span")({
  paddingLeft: "12px",
});

const ActionCause = ({ viewMode, isRequired = false }) => {
  const { t } = useTranslation();

  const { values } = useFormikContext();

  const isViewMode =
    viewMode === ACTION_VIEW_MODE.view || viewMode === ACTION_VIEW_MODE.edit;

  const hasCause = values?.caused?.stressId || values?.caused?.enemyId;

  return (
    <ActionTopBoxStyled>
      <CauseTitleSection>
        <Title title={t("ActionModal.Cause")} />
        <NormalText
          text={!isRequired && "(" + t("ActionModal.Optional") + ")"}
        />
      </CauseTitleSection>
      <StressTypeInput isViewMode={isViewMode} />
      <CauseTitleSection>
        <Title title={t("ActionModal.Stress")} />
        <NormalText
          text={!isRequired && "(" + t("ActionModal.Optional") + ")"}
        />
      </CauseTitleSection>
      {isViewMode && !hasCause ? (
        <EmptyPlaceholder>-</EmptyPlaceholder>
      ) : (
        <>
          <StressSelectInput isViewMode={isViewMode} />
          <EnemySelectInput isViewMode={isViewMode} />
        </>
      )}
    </ActionTopBoxStyled>
  );
};

export default ActionCause;
